import environment from "../environment/environment";

const api = {
  subscribe: "subscribe",
  login: "login",
  patients: "patients",
  medications: "medications",
  ask: `${environment.baseUrl}ask`,
  forms: "forms",
  getForm: "patient-forms",
  addReport: "patient-forms",
  removeReport: "patient-forms/delete/",
  drugs: "drugs",
  diseases: "disease",
  newsTabs: "news/tabs",
  newsSearch: "news/search",
  tabs: "tabs/filters",
  chat: "chat/send",
  threads: "threads",
  medicalCalculators: "calculators",
  filters: "tabs/filters",
  news: "news",
  config: "vars",
  cases: "cases",
};

export default api;
